import React, { useState, useEffect, Suspense, useRef } from 'react';
import NavBar from '../../../components/NavBar';
import { useNavigate } from 'react-router-dom';
import { IoIosArrowDown } from 'react-icons/io';
import Cookies from 'js-cookie';
import logoprefeitura from '../../../images/sinanImages/logoprefeitura.png';
import {
	requestSinanAgravos,
	requestSinanMunicipios,
	requestSinanUnidades,
	requestSinanBairros,
	requestSinanCep,
	requestSinanDistritos,
	requestSinanResolveCep,
	requestSinanMunicipioEnderecos,
	requestSinanMunicipioRegiaoSaude,
	requestSinanPaises,
	requestSinanRegioesSaude,
	requestSinanUfs,
	requestSinanZonas,
	requestSinanCreate,
} from '../../../services/sinanRequests';
import { useLocation } from 'react-router-dom';

// carrega TODOS os arquivos Criacao, Investigacao e Conclusao das subpastas
const modulos = require.context(
	'../../../components/sinan/fichas/',
	true,
	/(Criacao|Investigacao|Conclusao)\.js$/,
);

const SinanCreator = () => {
	const conteudoRef = useRef(null);
	const { state } = useLocation();
	let navigate = useNavigate();

	// ESTADOS EXISTENTES
	const [susList, setSusList] = useState([]);
	const [agravos, setAgravos] = useState([]);
	const [municipios, setMunicipios] = useState([]);
	const [unidades, setUnidades] = useState([]);

	const [valor, setValor] = useState('');
	const [componentes, setComponentes] = useState({
		Criacao: null,
		/* Investigacao: null,
	Conclusao: null, */
	});

	// ➕ NOVOS ESTADOS PARA TODAS AS NOVAS ROTAS
	const [bairros, setBairros] = useState([]);
	const [ceps, setCeps] = useState([]);
	const [distritos, setDistritos] = useState([]);
	const [resolveCep, setResolveCep] = useState([]);
	const [municipioEnderecos, setMunicipioEnderecos] = useState([]);
	const [municipioRegiaoSaude, setMunicipioRegiaoSaude] = useState([]);
	const [paises, setPaises] = useState([]);
	const [regioesSaude, setRegioesSaude] = useState([]);
	const [ufs, setUfs] = useState([]);
	const [zonas, setZonas] = useState([]);
	// dados da ficha dinâmica (Criacao)
	const [fichaData, setFichaData] = useState({});

	const handleRequestSomeInputs = async () => {
		// LÊ COOKIE USER
		const userCookie = Cookies.get('user');

		if (!userCookie) {
			console.error("Cookie 'user' não encontrado.");
			return;
		}

		let token = null;

		try {
			const parsed = JSON.parse(userCookie);
			token = parsed?.token;
		} catch (err) {
			console.error("Erro ao ler o cookie 'user':", err);
			return;
		}

		if (!token) {
			console.error("Token não encontrado dentro do cookie 'user'.");
			return;
		}

		try {
			// AGRAVOS
			const result = await requestSinanAgravos(token);

			if (result) setAgravos(result);

			// MUNICÍPIOS
			const result1 = await requestSinanMunicipios(token);
			if (result1) setMunicipios(result1);

			// UNIDADES
			const result2 = await requestSinanUnidades(token);
			if (result2) setUnidades(result2);

			// BAIRROS
			const resBairros = await requestSinanBairros(token);
			setBairros(resBairros);

			// CEPS — EXEMPLO (se for usar depois)
			// const resCeps = await requestSinanCep('20000-000', token);
			// setCeps(resCeps);

			// DISTRITOS
			const resDistritos = await requestSinanDistritos(token);
			setDistritos(resDistritos);

			// RESOLVE CEP
			const resResolve = await requestSinanResolveCep(
				{ cep: '20080-102' },
				token,
			);
			setResolveCep(resResolve);

			// MUNICÍPIO → ENDEREÇOS — EXEMPLO
			// const resEnderecos = await requestSinanMunicipioEnderecos(3304557, token);
			// setMunicipioEnderecos(resEnderecos);

			// MUNICÍPIO → REGIÃO SAÚDE
			const resRegiao = await requestSinanMunicipioRegiaoSaude(
				'3304557',
				token,
			);
			setMunicipioRegiaoSaude(resRegiao);

			// PAISES
			const resPaises = await requestSinanPaises(token);
			setPaises(resPaises);

			// REGIÕES DE SAÚDE
			const resRegioesSaude = await requestSinanRegioesSaude(token);
			setRegioesSaude(resRegioesSaude);

			// UFS
			const resUfs = await requestSinanUfs(token);
			setUfs(resUfs);

			// ZONAS
			const resZonas = await requestSinanZonas(token);
			setZonas(resZonas);
		} catch (error) {
			console.error('Erro ao carregar dados do SINAN:', error);
		}
	};

	// Estado para armazenar todos os dados do formulário
	const [formData, setFormData] = useState({
		// Dados Gerais
		tipoNotificacao: 'INDIVIDUAL',
		agravo: '',
		campoVazio: '',
		dataNotificacao: new Date().toISOString().split('T')[0],
		cid10: '',
		casoSuspeito: '',

		// Localização
		co_uf_notificacao: 'RJ',
		municipio_notificacao: 'Rio de Janeiro',
		co_municipio_notificacao: '3304557',
		unidadeNotificadora: '',
		/* codigoUnidade: '', */
		co_unidade_notificacao: '',
		codigoCNES: '',
		dt_primeiros_sintomas: '',

		// Notificação Individual
		paciente: '',
		dataNascimento: '',
		idade: '',
		tipoIdade: '',
		sexo: '',
		gestante: '',
		racaCor: '',
		escolaridade: '',
		cns: '',
		cpf: '',
		boletim: '',
		nomeMae: '',

		// Dados de Residência

		cep_res: '',
		uf_res: 'RJ',
		municipio_res: '',
		codigoIBGE_res: '',
		distrito_res: '',
		bairro_res: '',
		logradouro_res: '',
		codigo_res: '',
		numero_res: '',
		comprimento_res: '',
		geo_res_1: '',
		geo_res_2: '',
		referencia_res: '',
		zona_res: '',
		telefone_res: '',
		pais_res: '',

		// Tipo de ficha
		tipoFicha: 'INVESTIGACAO',
	});

	const escolaridadeOptions = [
		'Analfabeto',
		'1ª a 4ª série incompleta do EF (antigo primário ou 1º grau)',
		'4ª série completa do EF (antigo primário ou 1º grau)',
		'5ª a 8ª série incompleta do EF (antigo ginásio ou 1º grau)',
		'Ensino fundamental incompleto (antigo ginásio ou 1º grau)',
		'Ensino médio incompleto (antigo colegial ou 2º grau)',
		'Ensino médio completo (antigo colegial ou 2º grau)',
		'Educação superior incompleta',
		'Educação superior completa',
		'Ignorado',
		'Não se aplica',
	];

	// Estado para controlar campos com erro
	const [errors, setErrors] = useState({});
	const [formSend, setFormSend] = useState(false);

	const recebendoEstadoNavigate = () => {};

	// carrega dados iniciais apenas uma vez
	useEffect(() => {
		recebendoEstadoNavigate();
		handleRequestSomeInputs();
	}, []);

	// carrega o componente de criação assim que agravo e suspeita forem definidos
	useEffect(() => {
		if (!valor || !formData.campoVazio) {
			setComponentes({
				Criacao: null,
				/* Investigacao: null,
				Conclusao: null, */
			});
			return;
		}

		const carregarComponente = (nomeArquivo) => {
			const caminho = `./${valor}/${nomeArquivo}.js`;
			if (modulos.keys().includes(caminho)) {
				const modulo = modulos(caminho);
				return modulo.default;
			}
			return null;
		};

		setComponentes({
			Criacao: carregarComponente('Criacao'),
			/* Investigacao: carregarComponente('Investigacao'),
			Conclusao: carregarComponente('Conclusao'), */
		});
	}, [valor, formData.campoVazio]);

	const handleCep = async (cep) => {
		const userCookie = Cookies.get('user');
		let token = JSON.parse(userCookie).token
			? JSON.parse(userCookie).token
			: '';

		const resBairros = await requestSinanBairros(token);

		const result = await requestSinanCep(cep, token);

		if (!result.error) {
			setCeps(result);
			setFormData((prev) => ({
				...prev,
				uf_res: result?.uf?.sigla,
				municipio_res: result?.municipio?.nome,
				codigoIBGE_res: result?.municipio?.codigo_ibge,
				geo_res_1: result?.latitude,
				geo_res_2: result?.longitude,
				distrito_res: result?.distrito?.nome,
				bairro_res: '',
				logradouro_res: `${result?.tipo_logradouro}  ${result?.logradouro}`,
				codigo_res: '',
			}));
		}
	};

	const handleCreateFile = async () => {
		// LÊ COOKIE USER
		const userCookie = Cookies.get('user');
		if (!JSON.parse(userCookie).token) {
			console.error("Cookie 'user' não encontrado.");
		} else {
			let cookieToken = JSON.parse(userCookie).token;

			if (!fichaData || Object.keys(fichaData).length === 0) {
				alert(
					'É necessário preencher a ficha de investigação antes de enviar.',
				);
				return false;
			}

			const result = await requestSinanCreate(
				{
					...formData,
					paciente: {
						no_nome_paciente: formData.paciente,
						tp_raca_cor: formData.racaCor,
						tp_sexo: formData.sexo,
					},
					ficha: fichaData,
				},
				cookieToken,
			);

			if (result.error) {
				return false;
			} else {
				return true;
			}
		}
	};

	// Função para atualizar o estado do formulário
	const handleInputChange = (field, value) => {
		setFormData((prev) => ({
			...prev,
			[field]: value,
		}));

		// Remove o erro quando o campo é preenchido
		if (errors[field] && value) {
			setErrors((prev) => {
				const newErrors = { ...prev };
				delete newErrors[field];
				return newErrors;
			});
		}
	};

	const handleSusList = (val) => {
		const result = agravos.filter(
			(agravo) => agravo.ficha_related_name === val,
		);
		if (result) {
			setSusList(result);
		}
	};

	// Função para validar campos obrigatórios
	const validateForm = () => {
		const requiredFields = {
			tipoNotificacao: 'Tipo de Notificação *',
			agravo: 'Agravo/Doença',
			campoVazio: 'Suspeita *',
			dataNotificacao: 'Data da Notificação',
			cid10: 'CID10',
			dt_primeiros_sintomas: 'Data dos primeiros sintomas *',
			casoSuspeito: 'Caso Suspeito:',
			/* municipio_notificacao: 'Município da Notificação', */
			/* unidadeNotificadora: 'Unidade Notificadora', */
			co_unidade_notificacao: 'Unidade de Saúde',
			paciente: 'Nome do paciente',
			sexo: 'Sexo *',
			racaCor: 'Raça/cor *',
			/* cep_res: 'CEP *',
			uf_res: 'UF de residência *',
			municipio_res: 'Município de residência *',
			codigoIBGE_res: 'Código IBGE *',
			distrito_res: 'Distrito *',
			bairro_res: 'Bairro *',
			logradouro_res: 'Logradouro (rua, avenida)*',
			codigo_res: 'Código *',
			numero_res: 'Número *',
			comprimento_res: 'Complemento *',
			geo_res_1: 'Geo Campo 1 *',
			geo_res_2: 'Geo Campo 2 *',
			referencia_res: 'Ponto de Referência*',
			telefone_res: '(DDD) Telefone *',
			zona_res: 'Zona *',
			pais_res: 'País *', */
		};

		const newErrors = {};

		Object.keys(requiredFields).forEach((field) => {
			if (!formData[field] || formData[field].trim() === '') {
				newErrors[field] = true;
			}
		});

		// Validação especial: data de nascimento OU idade
		/* if (!formData.dataNascimento && !formData.idade) {
			newErrors.dataNascimento = true;
			newErrors.idade = true;
		} */

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	// Função para enviar o formulário
	const handleSubmit = async () => {
		if (validateForm()) {
			const requestResult = await handleCreateFile();
			if (requestResult === true) {
				setFormSend(true);
				alert('Formulário enviado com sucesso!');
				// Aqui você pode adicionar a lógica de envio para a API
			} else {
				alert('Erro ao enviar o formulário. Tente novamente.');
			}
		} else {
			alert('Por favor, preencha todos os campos obrigatórios!');
		}
	};

	// Função para salvar alterações
	const handleSave = () => {
		console.log('Salvando alterações...', formData);
		alert('Alterações salvas com sucesso!');
		// Aqui você pode adicionar a lógica de salvamento
	};

	// Função auxiliar para adicionar classe de erro
	const getErrorClass = (field) => {
		return errors[field]
			? 'border-red-500 border-2'
			: 'border-[#E3E3E3] border-[1px]';
	};

	return (
		<div className='flex flex-col min-h-screen'>
			<NavBar />

			<div className='min-h-screen w-full '>
				<div className='mt-[80px] font-inter flex flex-col min-h-screen  w-[90%] sm:w-[95%] py-[32px]  gap-2 mx-auto max-w-[1136px]'>
					{/* CABEÇALHO */}
					<button
						onClick={() => navigate('/sinan')}
						className='bg-[#ffffff] rounded-md p-1 voltar border-[#E3E3E3] text-[#757575] duration-300 transition-all  hover:bg-[#E3E3E3] border-[1px] w-[97px] h-[38px]'>
						voltar
					</button>
					<div className='bg-[#F0F4F8] flex justify-between rounded-[4px]  h-auto  p-[32px] w-full'>
						<div className='h-full my-auto'>
							<img
								alt='logo'
								className='w-[160px] h-auto'
								src={logoprefeitura}
							/>
						</div>
						<div className='flex flex-col text-center'>
							<p className='text-[32px] text-[#13335A] font-semibold'>
								SINAN
							</p>
							<p className='text-[20px] text-[#13335A]'>
								{' '}
								SISTEMA DE INFORMAÇÃO DE AGRAVOS NOTIFICAÇÃO
							</p>
						</div>
						<div className='flex flex-col '>
							<p className='text-[18px] text-[#13335A] font-semibold'>
								N° da notificação
							</p>
							<div className='bg-[#f5f5f5] rounded-md border-[1px] border-[#d8d8d8] text-[#d4d4d4] p-1'>
								000000
							</div>
						</div>
					</div>
					<select
						className='border px-2 py-2 rounded text-center font-medium text-[gray]'
						value={
							'INVESTIGACAO'
							/* formData.tipoFicha */
						}
						onChange={(e) =>
							handleInputChange('tipoFicha', e.target.value)
						}>
						<option value='INVESTIGACAO'>
							Ficha de Investigação
						</option>
						<option value='NOTIFICACAO'>
							Ficha de Notificação
						</option>
						<option value='CONCLUSAO'>Ficha de Conclusão</option>
					</select>
					<div
						className='relative rounded-md border overflow-hidden border-[#E3E3E3]'
						onClick={(e) => {
							const content =
								e.currentTarget.querySelector(
									'.conteudo-oculto',
								);
							content.classList.toggle('max-h-0');
							content.classList.toggle('max-h-[3000px]');
							content.classList.toggle('py-0');
							content.classList.toggle('py-2');
						}}>
						{formSend && (
							<div
								className='
			absolute inset-0 
			bg-[#E3E3E3]
      opacity-[20%]
			z-20 
			cursor-not-allowed
		'></div>
						)}
						<div className='bg-[#f7f7f7] text-[#13335A] font-semibold rounded-t-md p-2 cursor-pointer select-none'>
							<div className='flex justify-between'>
								DADOS GERAIS
								<IoIosArrowDown className='text-[#919191] w-[20px] h-auto' />
							</div>
						</div>

						<div
							className='conteudo-oculto max-h-0 transition-all duration-500 ease-in-out py-0 px-2'
							onClick={(e) => e.stopPropagation()}>
							<div className='text-sm  text-[#13335A]  w-[100%] lg:flex-row flex-col flex gap-[12px] '>
								<div className='w-full  max-w-[200px]'>
									<p>Tipo de Notificação *</p>
									<select
										value={formData.tipoNotificacao}
										onChange={(e) =>
											handleInputChange(
												'tipoNotificacao',
												e.target.value,
											)
										}
										className={`${getErrorClass(
											'tipoNotificacao',
										)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}>
										<option
											hidden
											disabled
											value=''>
											Selecione
										</option>
										<option value='NEGATIVA'>
											Negativa
										</option>
										<option value='INDIVIDUAL'>
											Individual
										</option>
										<option value='Surto'>Surto</option>
									</select>
								</div>
								<div className='w-full'>
									<p>Agravo/Doença *</p>
									<select
										value={formData.agravo}
										onChange={(e) => {
											const selected = agravos.find(
												(agravo) =>
													String(agravo.id_agravo) ===
													String(e.target.value),
											);

											if (!selected) {
												handleInputChange(
													'agravo',
													e.target.value,
												);
												return;
											}

											handleInputChange(
												'agravo',
												selected.id_agravo,
											);
											handleSusList(
												selected.ficha_related_name,
											);
											setValor(
												selected.ficha_related_name,
											);

											// abre a seção de localização quando um agravo é selecionado
											if (conteudoRef.current) {
												conteudoRef.current.classList.remove(
													'max-h-[0px]',
													'pb-0',
												);
												conteudoRef.current.classList.add(
													'max-h-[3000px]',
													'pb-2',
												);
											}
										}}
										className={`${getErrorClass(
											'agravo',
										)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px]`}>
										<option
											disabled
											hidden
											value=''>
											Selecione o agravo
										</option>
										{agravos?.length > 0 &&
											agravos
												.filter(
													(agravo, index, self) =>
														index ===
														self.findIndex(
															(a) =>
																a.ficha_related_name ===
																agravo.ficha_related_name,
														),
												)
												.map((agravo, index) => (
													<option
														key={agravo?.id + index}
														value={
															agravo?.id_agravo
														}>
														{agravo.no_agravo}
													</option>
												))}
									</select>
								</div>
								<div className='w-full'>
									<p className='text-[#13335A]'>Suspeita *</p>
									<select
										onChange={(e) => {
											handleInputChange(
												'campoVazio',
												e.target.value,
											);
											handleInputChange(
												'cid10',
												agravos.filter(
													(agravo) =>
														agravo.tp_suspeita ===
														e.target.value,
												)[0]?.cid,
											);
											handleInputChange(
												'casoSuspeito',
												agravos.filter(
													(agravo) =>
														agravo.tp_suspeita ===
														e.target.value,
												)[0]?.descricao,
											);
										}}
										className={`${getErrorClass(
											'campoVazio',
										)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px] placeholder-[#E3E3E3]`}>
										{susList.length > 0 ? (
											susList.map((susItem, index) => (
												<option
													key={
														susItem?.id +
														index +
														susItem.tp_suspeita
													}
													value={susItem.tp_suspeita}>
													{susItem.tp_suspeita}
												</option>
											))
										) : (
											<option value=''>
												Nenhuma suspeita disponível
											</option>
										)}
									</select>
								</div>
								<div className='w-full max-w-[180px]'>
									<p>Data da Notificação *</p>

									<input
										type='date'
										value={formData.dataNotificacao}
										onChange={(e) =>
											handleInputChange(
												'dataNotificacao',
												e.target.value,
											)
										}
										className={`${getErrorClass(
											'dataNotificacao',
										)} text-[#4F5257] h-[40px] px-1  rounded-[8px]  w-full`}
									/>
								</div>
								<div className=''>
									<p>CID10 *</p>

									<input
										type='text'
										placeholder='CID10'
										value={formData.cid10}
										onChange={(e) =>
											handleInputChange(
												'cid10',
												e.target.value,
											)
										}
										className={`${getErrorClass(
											'cid10',
										)} text-[#4F5257] h-[40px] px-1 rounded-[8px]  placeholder-[#E3E3E3] max-w-[100px]`}
									/>
								</div>
							</div>
							<div
								className={`text-sm border-[#E3E3E3] w-full text-[#13335A] py-1 px-2 mt-3 rounded-[8px] h-auto border-[1px]
								${getErrorClass('casoSuspeito')}
								`}>
								<p>Caso Suspeito:</p>

								<textarea
									className={`w-full h-auto text-[#4F5257] resize-none focus:outline-none placeholder-[#E3E3E3]text-base  rounded-lg  min-h-[100px] transition-all overflow-hidden `}
									value={formData.casoSuspeito}
									onChange={(e) => {
										handleInputChange(
											'casoSuspeito',
											e.target.value,
										);

										// AUTO-RESIZE
										e.target.style.height = 'auto';
										e.target.style.height = `${e.target.scrollHeight}px`;
									}}
									rows={1} // começa pequeno
								/>
							</div>

							<hr className='my-3'></hr>
							{/* LOCALIZAÇÃO DA NOTIFICAÇÃO */}
							<div
								ref={conteudoRef}
								className={`localizacao-oculto overflow-hidden transition-all duration-300 flex gap-2 pb-0 max-h-0  text-sm text-[#13335A]  w-[100%] 
              flex-col`}>
								<div className='w-full flex gap-3'>
									<div className='w-full  max-w-[80px]'>
										<p>UF</p>
										<select
											disabled={true}
											className={`${getErrorClass(
												'uf',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
											value={formData.uf}
											/* onChange={(e) =>
												handleInputChange(
													'uf',
													e.target.value
												)
											} */
										>
											<option value='RJ'>RJ</option>
										</select>
									</div>
									<div className='w-full '>
										<p>Município da Notificação</p>
										<select
											value={
												'Rio de Janeiro'
												/* formData.municipio_notificacao */
											}
											onChange={(e) => {
												handleInputChange(
													'municipio_notificacao',
													e.target.value,
												);
												handleInputChange(
													'co_municipio_notificacao',
													municipios.filter(
														(muni) =>
															muni.nome ===
															e.target.value,
													)[0]?.codigo_ibge,
												);
											}}
											className={`${getErrorClass(
												'municipio_notificacao',
											)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px]`}>
											<option
												disabled
												hidden
												value=''>
												Selecione o município
											</option>
											{municipios?.length > 0 &&
												municipios.map(
													(municipio, index) => (
														<option
															value={
																municipio.nome
															}
															key={
																index +
																municipio.nome
															}>
															{municipio.nome}
														</option>
													),
												)}
										</select>
									</div>
									<div className='w-full max-w-[200px]'>
										<p>Código IBGE</p>
										<input
											type='text'
											disabled={true}
											placeholder='Código IBGE'
											value={
												'3304557'
												/* formData.codigoIBGE */
											}
											onChange={(e) =>
												handleInputChange(
													'co_municipio_notificacao',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'co_municipio_notificacao',
											)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px] placeholder-[#E3E3E3]`}
										/>
									</div>
								</div>
								{/* <div className='w-full flex gap-3'>
									<div className='w-full  '>
										<p>Unidade Notificadora *</p>
										<select
											className={`${getErrorClass(
												'unidadeNotificadora'
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
											value={formData.unidadeNotificadora}
											onChange={(e) =>
												handleInputChange(
													'unidadeNotificadora',
													e.target.value
												)
											}>
											<option
												hidden
												disabled
												value=''>
												Selecione
											</option>
											<option value='unidade1'>
												Nome da Unidade 1
											</option>
											<option value='unidade2'>
												Nome da Unidade 2
											</option>
										</select>
									</div>

									<div className='w-full max-w-[200px]'>
										<p>Código Unidade</p>
										<input
											type='text'
											placeholder='Código Unidade'
											value={formData.codigoUnidade}
											onChange={(e) =>
												handleInputChange(
													'codigoUnidade',
													e.target.value
												)
											}
											className={`${getErrorClass(
												'codigoUnidade'
											)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px] placeholder-[#E3E3E3]`}
										/>
									</div>
								</div> */}
								<div className='w-full flex gap-3 flex-wrap lg:flex-nowrap'>
									<div className='w-full  min-w-[400px]'>
										<div>
											Unidade de Saúde{' '}
											<span className='text-gray-500'>
												(ou outra fonte notificadora) *
											</span>
										</div>
										<select
											className={`${getErrorClass(
												'co_unidade_notificacao',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
											value={
												formData.co_unidade_notificacao
											}
											onChange={(e) => {
												handleInputChange(
													'co_unidade_notificacao',
													e.target.value,
												);

												handleInputChange(
													'codigoCNES',
													unidades.filter(
														(unidade) =>
															unidade.id ===
															e.target.value,
													)[0]?.cnes,
												);
											}}>
											<option
												hidden
												disabled
												value=''>
												Selecione
											</option>
											{unidades?.length > 0 &&
												unidades?.map((unidade) => (
													<option
														value={unidade.id}
														key={unidade.id + 'ah'}>
														{unidade.nome}
													</option>
												))}
										</select>
									</div>

									<div className='w-full max-w-[200px]'>
										<p>Código CNES</p>
										<input
											type='text'
											placeholder='Código CNES'
											value={formData.codigoCNES}
											disabled={true}
											onChange={(e) =>
												handleInputChange(
													'codigoCNES',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'codigoCNES',
											)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px] placeholder-[#E3E3E3]`}
										/>
									</div>
									<div className='w-full max-w-[300px] min-w-[100px]'>
										<p>Data dos primeiros sintomas * </p>
										<input
											type='date'
											value={
												formData.dt_primeiros_sintomas
											}
											onChange={(e) => {
												handleInputChange(
													'dt_primeiros_sintomas',
													e.target.value,
												);
											}}
											className={`${getErrorClass(
												'dt_primeiros_sintomas',
											)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px] placeholder-[#E3E3E3]`}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* NOTIFICAÇÃO INDIVIDUAL */}
					<div
						className='relative rounded-md border overflow-hidden border-[#E3E3E3]'
						onClick={(e) => {
							const content =
								e.currentTarget.querySelector(
									'.conteudo-oculto-2',
								);
							content.classList.toggle('max-h-0');
							content.classList.toggle('max-h-[3000px]');
							content.classList.toggle('py-0');
							content.classList.toggle('py-2');
						}}>
						{formSend && (
							<div
								className='
			absolute inset-0 
			bg-[#E3E3E3]
      opacity-[20%]
			z-20 
			cursor-not-allowed
		'></div>
						)}
						<div className='bg-[#f7f7f7] text-[#13335A] font-semibold rounded-t-md p-2 cursor-pointer select-none'>
							<div className='flex justify-between'>
								NOTIFICAÇÃO INDIVIDUAL
								<IoIosArrowDown className='text-[#919191] w-[20px] h-auto' />
							</div>
						</div>
						<div
							className='conteudo-oculto-2 max-h-0 transition-all duration-500 ease-in-out py-0 px-2'
							onClick={(e) => e.stopPropagation()}>
							<div
								className='text-sm  text-[#13335A] gap-2 w-[100%] 
              flex-col flex '>
								<div className='w-full flex gap-2 sm:flex-nowrap flex-wrap'>
									<div className='w-full  min-w-[300px]'>
										<p>Nome do paciente *</p>
										<input
											type='text'
											placeholder='Nome do paciente'
											value={formData.paciente}
											onChange={(e) =>
												handleInputChange(
													'paciente',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'paciente',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full max-w-[230px]'>
										<p>Data de nascimento</p>
										<input
											type='date'
											value={formData.dataNascimento}
											onChange={(e) =>
												handleInputChange(
													'dataNascimento',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'dataNascimento',
											)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px]`}
										/>
									</div>
									<div className='w-full max-w-[78px]'>
										<div className='flex gap-[3px]'>
											{' '}
											<span className='text-gray-500'>
												(ou)
											</span>
											Idade
										</div>

										<input
											type='text'
											placeholder='Número'
											value={formData.idade}
											onChange={(e) =>
												handleInputChange(
													'idade',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'idade',
											)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px] placeholder-[#E3E3E3]`}
										/>
									</div>
									<div className='flex flex-col text-gray-500 '>
										<label className='flex gap-1 h-[15px] items-center'>
											<input
												type='radio'
												name='data'
												value='hora'
												checked={
													formData.tipoIdade ===
													'hora'
												}
												onChange={(e) =>
													handleInputChange(
														'tipoIdade',
														e.target.value,
													)
												}
											/>
											Hora
										</label>
										<label className='flex gap-1 h-[15px] items-center'>
											<input
												type='radio'
												name='data'
												value='dia'
												checked={
													formData.tipoIdade === 'dia'
												}
												onChange={(e) =>
													handleInputChange(
														'tipoIdade',
														e.target.value,
													)
												}
											/>
											Dia
										</label>
										<label className='flex gap-1 h-[15px] items-center'>
											<input
												type='radio'
												name='data'
												value='mes'
												checked={
													formData.tipoIdade === 'mes'
												}
												onChange={(e) =>
													handleInputChange(
														'tipoIdade',
														e.target.value,
													)
												}
											/>
											Mês
										</label>
										<label className='flex gap-1 h-[15px] items-center'>
											<input
												type='radio'
												name='data'
												value='ano'
												checked={
													formData.tipoIdade === 'ano'
												}
												onChange={(e) =>
													handleInputChange(
														'tipoIdade',
														e.target.value,
													)
												}
											/>
											Ano
										</label>
									</div>
								</div>
								<div className='w-full flex gap-2 lg:flex-nowrap flex-wrap'>
									<div className='w-full  min-w-[200px]'>
										<p>Sexo *</p>
										<select
											className={`${getErrorClass(
												'sexo',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
											value={formData.sexo}
											onChange={(e) =>
												handleInputChange(
													'sexo',
													e.target.value,
												)
											}>
											<option
												hidden
												disabled
												value=''>
												Selecione
											</option>
											<option value='M'>Masculino</option>
											<option value='F'>Feminino</option>
											<option value='I'>Ignorado</option>
										</select>
									</div>
									<div className='w-full lg:max-w-[200px]  min-w-[200px]'>
										<p>Gestante</p>
										<select
											className={`${getErrorClass(
												'gestante',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
											value={formData.gestante}
											onChange={(e) =>
												handleInputChange(
													'gestante',
													e.target.value,
												)
											}>
											<option
												disabled
												hidden
												value=''>
												Selecione
											</option>
											<option value='1'>
												1º Trimestre
											</option>
											<option value='2'>
												2º Trimestre
											</option>
											<option value='3'>
												3º Trimestre
											</option>
											<option value='ignorada'>
												Idade gestacional ignorada
											</option>
											<option value='nao'>Não</option>
											<option value='nao-aplica'>
												Não se aplica
											</option>
											<option value='ignorado'>
												Ignorado
											</option>
										</select>
									</div>
									<div className='w-full lg:max-w-[200px] min-w-[200px]'>
										<p>Raça/cor *</p>
										<select
											className={`${getErrorClass(
												'racaCor',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
											value={formData.racaCor}
											onChange={(e) =>
												handleInputChange(
													'racaCor',
													e.target.value,
												)
											}>
											<option
												disabled
												hidden
												value=''>
												Selecione
											</option>
											<option value='0'>Negra</option>
											<option value='1'>Parda</option>
											<option value='2'>Branca</option>
											<option value='3'>Indigena</option>
											<option value='4'>Amarela</option>
											<option value='5'>Ignorado</option>
										</select>
									</div>
									<div className='w-full min-w-[200px]'>
										<p>Escolaridade</p>

										<select
											className={`${getErrorClass(
												'escolaridade',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
											value={formData.escolaridade}
											onChange={(e) =>
												handleInputChange(
													'escolaridade',
													e.target.value,
												)
											}>
											<option
												disabled
												hidden
												value=''>
												Selecione
											</option>

											{escolaridadeOptions.map(
												(item, idx) => (
													<option
														key={item + idx}
														value={item}>
														{item}
													</option>
												),
											)}
										</select>
									</div>
								</div>
								<div className='w-full flex gap-2 lg:flex-nowrap flex-wrap '>
									<div className='w-full lg:max-w-[400px]  min-w-[300px]'>
										<p>Cartão Nacional de Saúde (CNS)</p>
										<input
											type='text'
											placeholder='Número do CNS'
											value={formData.cns}
											onChange={(e) =>
												handleInputChange(
													'cns',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'cns',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full lg:max-w-[230px]'>
										<p>CPF</p>
										<input
											type='text'
											placeholder='CPF'
											value={formData.cpf}
											onChange={(e) =>
												handleInputChange(
													'cpf',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'cpf',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full lg:max-w-[180px]'>
										<div className='flex gap-1'>
											{' '}
											Boletim
											<p className='text-gray-500'>
												(prontuário)
											</p>
										</div>
										<input
											type='text'
											placeholder='Boletim'
											value={formData.boletim}
											onChange={(e) =>
												handleInputChange(
													'boletim',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'boletim',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full lg:max-w-[400px]'>
										<div className='flex gap-1'>
											{' '}
											Nome da mãe
											<p className='text-gray-500'>
												(prontuário)
											</p>
										</div>

										<input
											type='text'
											placeholder='Nome da mãe'
											value={formData.nomeMae}
											onChange={(e) =>
												handleInputChange(
													'nomeMae',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'nomeMae',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* DADOS DE RESIDÊNCIA */}
					<div
						className='relative rounded-md border overflow-hidden border-[#E3E3E3]'
						onClick={(e) => {
							const content = e.currentTarget.querySelector(
								'.conteudo-oculto-3', // Alterado para um nome de classe diferente para este bloco
							);
							content.classList.toggle('max-h-0');
							content.classList.toggle('max-h-[3000px]');
							content.classList.toggle('py-0');
							content.classList.toggle('py-2');
						}}>
						{formSend && (
							<div
								className='
			absolute inset-0 
			bg-[#E3E3E3]
      opacity-[20%]
			z-20 
			cursor-not-allowed
		'></div>
						)}
						<div className='bg-[#f7f7f7] text-[#13335A] font-semibold rounded-t-md p-2 cursor-pointer select-none'>
							<div className='flex justify-between'>
								DADOS DE RESIDÊNCIA
								<IoIosArrowDown className='text-[#919191] w-[20px] h-auto' />
							</div>
						</div>
						<div
							className='conteudo-oculto-3 max-h-0 transition-all duration-500 ease-in-out py-0 px-2' // Alterado para um nome de classe diferente
							onClick={(e) => e.stopPropagation()}>
							<div
								className='text-sm  text-[#13335A] gap-2 w-[100%] 
              flex-col flex '>
								{/* Linha 1: CEP, UF, Município, Código IBGE, Distrito */}
								<div className='w-full flex gap-2 sm:flex-nowrap flex-wrap'>
									<div className='w-full max-w-[150px] min-w-[100px]'>
										<p>CEP </p>
										<input
											type='text'
											placeholder='CEP'
											value={formData.cep_res}
											onChange={(e) => {
												handleInputChange(
													'cep_res',
													e.target.value,
												);
												handleCep(e.target.value);
											}}
											className={`${getErrorClass(
												'cep_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full max-w-[100px] min-w-[70px]'>
										<p>UF </p>
										<input
											type='text'
											placeholder='UF'
											value={formData.uf_res}
											onChange={(e) =>
												handleInputChange(
													'uf_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'uf_res',
											)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px]`}
										/>
									</div>
									<div className='w-full min-w-[200px]'>
										<p>Município de residência</p>
										<input
											type='text'
											placeholder='Município'
											value={formData.municipio_res}
											onChange={(e) =>
												handleInputChange(
													'municipio_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'municipio_res',
											)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px]`}
										/>
									</div>
									<div className='w-full max-w-[150px] min-w-[100px]'>
										<p>Código IBGE </p>
										<input
											type='text'
											placeholder='Cód. IBGE'
											value={formData.codigoIBGE_res}
											onChange={(e) =>
												handleInputChange(
													'codigoIBGE_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'codigoIBGE_res',
											)} text-[#4F5257] w-full h-[40px] px-1 rounded-[8px]`}
										/>
									</div>
									<div className='w-full min-w-[200px]'>
										<p>Distrito </p>
										<input
											type='text'
											placeholder='Distrito'
											value={formData.distrito_res}
											onChange={(e) =>
												handleInputChange(
													'distrito_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'distrito_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
								</div>
								{/* Linha 2:  Bairro, Logradouro, Código Logradouro, Número */}
								<div className='w-full flex gap-2 lg:flex-nowrap flex-wrap'>
									<div className='w-full min-w-[200px]'>
										<p>Bairro </p>
										<input
											type='text'
											placeholder='Bairro'
											value={formData.bairro_res}
											onChange={(e) =>
												handleInputChange(
													'bairro_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'bairro_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full min-w-[300px]'>
										<p>Logradouro (rua, avenida...) </p>
										<input
											type='text'
											placeholder='Logradouro'
											value={formData.logradouro_res}
											onChange={(e) =>
												handleInputChange(
													'logradouro_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'logradouro_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full max-w-[150px] min-w-[100px]'>
										<p>Código </p>
										<input
											type='text'
											placeholder='Código'
											value={formData.codigo_res}
											onChange={(e) =>
												handleInputChange(
													'codigo_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'codigo_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full max-w-[100px] min-w-[70px]'>
										<p>Número </p>
										<input
											type='text'
											placeholder='Número'
											value={formData.numero_res}
											onChange={(e) =>
												handleInputChange(
													'numero_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'numero_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
								</div>

								{/* Linha 3: Número, Complemento,Geocampo 1, Geocampo 2 */}
								<div className='w-full flex gap-2 lg:flex-nowrap flex-wrap '>
									<div className='w-full max-w-[300px] min-w-[200px]'>
										<p>Complemento </p>
										<input
											type='text'
											placeholder='Ex: apto 101'
											value={formData.comprimento_res}
											onChange={(e) =>
												handleInputChange(
													'comprimento_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'comprimento_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full  min-w-[100px]'>
										<p>Geo Campo 1 </p>
										<input
											type='text'
											placeholder='Geo 1'
											value={formData.geo_res_1}
											onChange={(e) =>
												handleInputChange(
													'geo_res_1',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'geo_res_1',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full  min-w-[100px]'>
										<p>Geo Campo 2 </p>
										<input
											type='text'
											placeholder='Geo 2'
											value={formData.geo_res_2}
											onChange={(e) =>
												handleInputChange(
													'geo_res_2',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'geo_res_2',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
								</div>
								{/* Linha 4:  ponto de referência ,Zona, País */}
								<div className='w-full flex gap-2 lg:flex-nowrap flex-wrap '>
									<div className='w-full min-w-[300px]'>
										<p>Ponto de Referência </p>
										<input
											type='text'
											placeholder='Ponto de Referência'
											value={formData.referencia_res}
											onChange={(e) =>
												handleInputChange(
													'referencia_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'referencia_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full min-w-[300px]'>
										<p>(DDD) Telefone </p>
										<input
											type='tel'
											placeholder='000000'
											value={formData.telefone_res}
											onChange={(e) =>
												handleInputChange(
													'telefone_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'telefone_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
									<div className='w-full max-w-[200px] min-w-[150px]'>
										<p>Zona </p>
										<select
											className={`${getErrorClass(
												'zona_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
											value={formData.zona_res}
											onChange={(e) =>
												handleInputChange(
													'zona_res',
													e.target.value,
												)
											}>
											<option
												hidden
												disabled
												value=''>
												Selecione
											</option>
											<option value='urbana'>
												Urbana
											</option>
											<option value='rural'>Rural</option>
											<option value='periurbana'>
												Periurbana
											</option>
										</select>
									</div>
									<div className='w-full max-w-[250px] min-w-[200px]'>
										<p>País </p>
										<input
											type='text'
											placeholder='País'
											value={formData.pais_res}
											onChange={(e) =>
												handleInputChange(
													'pais_res',
													e.target.value,
												)
											}
											className={`${getErrorClass(
												'pais_res',
											)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className=' space-y-6 w-full '>
						<Suspense fallback={<p>Carregando componentes...</p>}>
							{componentes.Criacao && (
								<div className='rounded-lg bg-white '>
									<componentes.Criacao
										agravo={formData.agravo}
										suspeita={formData.campoVazio}
										dadosGerais={formData}
										onChange={setFichaData}
									/>
								</div>
							)}
							{/* {componentes.Investigacao && (
								<div className='rounded-lg  bg-white '>
									<componentes.Investigacao />
								</div>
							)}
							{componentes.Conclusao && (
								<div
									className='rounded-lg  bg-white
                '>
									<componentes.Conclusao />
								</div>
							)} */}
							{!componentes.Criacao &&
								!componentes.Investigacao &&
								!componentes.Conclusao &&
								formSend === true &&
								null}
						</Suspense>
					</div>
					<div
						className={`w-full  justify-between ${
							!formSend ? 'flex' : 'hidden'
						}`}>
						<button
							onClick={handleSave}
							className='bg-[#ffffff] rounded-md p-1 voltar border-[#E3E3E3] text-[#757575] duration-300 transition-all  hover:bg-[#E3E3E3] border-[1px] px-[26px] shadow-sm h-[38px]'>
							Salvar Alterações
						</button>
						<button
							onClick={handleSubmit}
							className='bg-[#ffffff] rounded-md p-1 voltar border-[#E3E3E3] text-[#757575] duration-300 transition-all  hover:bg-[#E3E3E3] border-[1px] shadow-sm w-[180px] h-[38px]'>
							Enviar
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SinanCreator;
